var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebdev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ccd3eb;}.cls-2{fill:#f5f7ff;}.cls-3{fill:#96a1c3;}.cls-4{fill:#647499;}.cls-5{fill:url(#linear-gradient);}.cls-6{fill:#0074ff;}.cls-7{fill:#d7e9f7;}.cls-8{fill:#4795ea;}.cls-9{fill:#eb7f58;}.cls-10{fill:#b4cde1;}.cls-11{fill:#f0f7fc;}.cls-12{fill:#033c59;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 30,
    y1: 44.96,
    x2: 34,
    y2: 44.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d3e6f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f7fc"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Web development") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web_development",
    "data-name": "Web development"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60,12V40H4V12A6,6,0,0,1,8,6.35,5.8,5.8,0,0,1,10,6H54A6,6,0,0,1,60,12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M57,12V40H4V12A6,6,0,0,1,8,6.35,5.8,5.8,0,0,1,10,6H51A6,6,0,0,1,57,12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M60,40v4a6,6,0,0,1-6,6H10a6,6,0,0,1-6-6V40Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "42.29 61.95 21.71 61.95 25.83 49.95 38.17 49.95 42.29 61.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M33,46H31a1,1,0,0,1,0-2h2a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M55,4v8H9V4a2,2,0,0,1,2-2H53A2,2,0,0,1,55,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M55,12V33a2,2,0,0,1-2,2H11a2,2,0,0,1-2-2V12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M49,9a2,2,0,1,1,2-2A2,2,0,0,1,49,9Zm0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M43,9a2,2,0,1,1,2-2A2,2,0,0,1,43,9Zm0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M37,9a2,2,0,1,1,2-2A2,2,0,0,1,37,9Zm0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M31,8H14a1,1,0,0,1,0-2H31a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M15,28a1,1,0,0,1-.83-.45l-2-3a1,1,0,0,1,0-1.1l2-3a1,1,0,0,1,1.66,1.1L14.2,24l1.63,2.45a1,1,0,0,1-.28,1.38A.94.94,0,0,1,15,28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M23,28a.94.94,0,0,1-.55-.17,1,1,0,0,1-.28-1.38L23.8,24l-1.63-2.45a1,1,0,1,1,1.66-1.1l2,3a1,1,0,0,1,0,1.1l-2,3A1,1,0,0,1,23,28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M18,28.87a1.07,1.07,0,0,1-.25,0A1,1,0,0,1,17,27.62l2-7.74a1,1,0,0,1,1.94.5l-2,7.74A1,1,0,0,1,18,28.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M40,31H32a2,2,0,0,1-1.41-.59l3.68-3.68a2,2,0,0,1,3.08.3L38,28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M51,19V29a1.91,1.91,0,0,1-.56,1.37l-5.9-6.63a2,2,0,0,0-3,.05L38,28l-.65-1a2,2,0,0,0-3.08-.3l-3.68,3.68A2,2,0,0,1,30,29V19a2,2,0,0,1,2-2H49A2,2,0,0,1,51,19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M50.44,30.37A1.93,1.93,0,0,1,49,31H40l-2-3,3.51-4.21a2,2,0,0,1,3-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M36,24a2,2,0,1,1,2-2A2,2,0,0,1,36,24Zm0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M33,44H31a1,1,0,0,0,0,2h2a1,1,0,0,0,0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M56,5.3V4a3,3,0,0,0-3-3H49a1,1,0,0,0,0,2h4a1,1,0,0,1,1,1v7H10V4a1,1,0,0,1,1-1H40a1,1,0,0,0,0-2H11A3,3,0,0,0,8,4V5.3A7,7,0,0,0,3,12V44a7,7,0,0,0,7,7H24.43L21,61H20a1,1,0,0,0,0,2H44a1,1,0,0,0,0-2H43L39.57,51H54a7,7,0,0,0,7-7V12A7,7,0,0,0,56,5.3ZM54,13V33a1,1,0,0,1-1,1H11a1,1,0,0,1-1-1V13ZM8,7.44V33a3,3,0,0,0,3,3H53a3,3,0,0,0,3-3V7.44A4.94,4.94,0,0,1,59,12V39H5V12A4.94,4.94,0,0,1,8,7.44ZM40.89,61H23.11l3.43-10H37.46ZM54,49H10a5,5,0,0,1-5-5V41H59v3A5,5,0,0,1,54,49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M44,3h1a1,1,0,0,0,0-2H44a1,1,0,0,0,0,2Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 49,
    cy: 7,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 43,
    cy: 7,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 37,
    cy: 7,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14,6a1,1,0,0,0,0,2H31a1,1,0,0,0,0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M14.17,27.55A1,1,0,0,0,15,28a.94.94,0,0,0,.55-.17,1,1,0,0,0,.28-1.38L14.2,24l1.63-2.45a1,1,0,0,0-1.66-1.1l-2,3a1,1,0,0,0,0,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M22.45,27.83A.94.94,0,0,0,23,28a1,1,0,0,0,.83-.45l2-3a1,1,0,0,0,0-1.1l-2-3a1,1,0,1,0-1.66,1.1L23.8,24l-1.63,2.45A1,1,0,0,0,22.45,27.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M17.75,28.84a1.07,1.07,0,0,0,.25,0,1,1,0,0,0,1-.75l2-7.74a1,1,0,0,0-1.94-.5l-2,7.74A1,1,0,0,0,17.75,28.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M32,32H49a3,3,0,0,0,3-3V19a3,3,0,0,0-3-3H32a3,3,0,0,0-3,3V29A3,3,0,0,0,32,32Zm8.53-2-1.28-1.93,3-3.64a1,1,0,0,1,.76-.36.85.85,0,0,1,.75.34l5,5.59Zm-2.4,0H32.41L35,27.44a1,1,0,0,1,.81-.3,1,1,0,0,1,.73.45ZM32,18H49a1,1,0,0,1,1,1v9.37l-4.71-5.29a3,3,0,0,0-2.24-1h0a3,3,0,0,0-2.28,1.08l-2.67,3.2A3,3,0,0,0,33.56,26L31,28.59V19A1,1,0,0,1,32,18Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 36,
    cy: 22,
    r: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebdev);
export default __webpack_public_path__ + "static/media/webdev.b8d7563e2fd9fa29b99d080bad638df3.svg";
export { ForwardRef as ReactComponent };